import styled from "styled-components";

interface PagesClientSearchResultCountPillProps {
  resultCount?: number;
}
const StyledResultHeaderBadge = styled.h4``;
export const PagesClientSearchResultCountPilll = ({
  resultCount
}: PagesClientSearchResultCountPillProps) => {
  const resultCountWithCommas = resultCount
    ? resultCount.toLocaleString()
    : "0";

  const resultCountText =
    resultCount && resultCount > 0
      ? `${resultCountWithCommas} Matching Results`
      : "";
  return <StyledResultHeaderBadge>{resultCountText}</StyledResultHeaderBadge>;
};
